// extracted by mini-css-extract-plugin
export default {"container":"basic-modal-component_container__2sf34","truncate-table":"basic-modal-component_truncate-table__nzh4V","table-text-faded":"basic-modal-component_table-text-faded__oEAJ8","buttons":"basic-modal-component_buttons__ozynS","description":"basic-modal-component_description__WFLeU"};
    if(module.hot) {
      // 1792500640859
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  